import React from 'react';
import { PropTypes } from 'prop-types';

import AlertDialog from '../../AlertDialog';

const FailureReasonModal = ({ onDismiss, details }) => (
  <AlertDialog
    open={!!details}
    title="Failure Reason"
    onDismiss={onDismiss}
  >
    {details}
  </AlertDialog>
);

FailureReasonModal.propTypes = {
  onDismiss: PropTypes.func,
  details: PropTypes.string,
};

export default FailureReasonModal;
